export const setupStatusMessages = {
  modeHelp:
    'This only changes what the Admin displays. It never creates or removes Cloudflare resources.',
  simpleMode: 'Simple mode',
  simpleModeHelp:
    'Daily link management with shorter navigation and one-domain deployment guidance.',
  advancedMode: 'Advanced mode',
  advancedModeHelp:
    'Analytics, automation, multiple domains, backups, tokens, rules, and operations tools.',
  instanceStatus: 'Instance status for this deployment',
  refresh: 'Refresh',
  selfHosting: 'Self-hosting',
  checksOk: 'Checks OK',
  warnings: 'Warnings',
  failures: 'Failures',
  workerApi: 'Worker API',
  apiResponding: 'Authenticated API requests are responding',
  apiNotResponding: 'Authenticated API requests are not responding',
  adminApiOrigin: 'Admin API origin',
  defaultShortDomain: 'Default short domain',
  noDefaultDomain: 'No default domain saved',
  firstLink: 'First link',
  linksCreated: '{count} link(s) created',
  noLinks: 'No links created yet',
  openSettings: 'Open Settings',
  openLinks: 'Open Links',
  domainCatalog: 'Domain catalog',
  activeDomains: '{count} active domain(s)',
  noActiveDomains: 'No active domains registered',
  openDomains: 'Open Domains',
  r2Backups: 'R2 backups',
  backupRecords: '{count} backup record(s)',
  r2Unavailable: 'R2 backup binding is not available',
  openBackups: 'Open Backups',
  noDefaultDomainShort: 'No default domain',
  active: '{count} active',
  total: '{count} total',
  r2Ready: 'R2 ready',
  advancedCapabilities: 'Advanced deployment capabilities',
  optionalEnabled: '{count} of 3 optional capabilities enabled',
  profile: '{value} profile',
  coreStorage: 'Core storage',
  coreStorageReady: 'D1 and KV are available',
  scheduledBackupReady: 'Scheduled backup binding available',
  addR2: 'Add both R2 bucket variables',
  visitQueue: 'Visit queue',
  queueReady: 'Asynchronous visit processing available',
  addQueue: 'Add LINKETRY_VISITS_QUEUE',
  multipleDomains: 'Multiple domains',
  configuredDomains: '{count} configured domain(s)',
  configureAdvanced: 'Configure advanced capabilities',
  statusOk: 'ok',
  statusWarn: 'warn',
  statusFail: 'fail',
  wizardTitle: 'Quick deployment wizard',
  wizardDescription: 'Complete these three required steps to start using Linketry.',
  wizardComplete: 'Basic deployment is ready. You can create and manage short links now.',
  wizardProgress: '{completed} of {total} complete',
  wizardApiTitle: 'Connect the Worker API',
  wizardApiReady: 'Authenticated API and core bindings are responding.',
  wizardApiPending: 'Check the API Origin, LINKETRY_ADMIN_TOKEN, D1, and KV deployment.',
  wizardDomainTitle: 'Choose the default short domain',
  wizardDomainPending: 'Save the single Worker domain used for public short links.',
  wizardLinkTitle: 'Create the first short link',
  wizardLinkReady: '{count} link(s) available.',
  wizardLinkPending: 'Create one link and verify its public redirect.',
  wizardOneDomain:
    'Easy setup: use the automatic linketry-admin.pages.dev URL for Admin and configure only go.example.com for the API and short links.',
  wizardAdvancedOptional: 'Configure optional advanced resources',
} as const;
